import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServidorSidebarComponent } from './servidor-sidebar.component';
import { BackConfirmModule, PipeModule, PanelModule } from '@elotech/angular-common';

@NgModule({
  imports: [
    CommonModule,
    PanelModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    BackConfirmModule
  ],
  declarations: [ServidorSidebarComponent],
  exports: [ServidorSidebarComponent],
  providers: []
})
export class ServidorSidebarModule {
}
